// CacheKey 07952b806257b1a813ec44cc8696de74
//
// DO NOT MODIFY: This file was automatically generated by JsFromTranslations.
export default {
  es: {
    rounding: {
      answer_details: {
        placeholder: "Detalles…"
      },
      free_text_response: "Por favor ingrese la respuesta aquí",
      care_note_text_response: "Introduzca sus comentarios aquí",
      caregram: {
        message: "Por favor ingrese la respuesta aquí"
      },
      details_question: {
        disabled: "Por favor seleccione una respuesta anterior",
        response: "Por favor ingrese la respuesta aquí"
      }
    },
    webform: {
      question_header: "Su salud nos importa."
    }
  }
}

